import { FC } from 'react';
import styled from 'styled-components';

interface Props {}

const Container = styled.div`
  bottom: 30px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-bottom: 0;
  position: absolute;

  & p {
    text-align: center;
    font-size: 0.9em;
    margin: 0;
  }

  & img {
    border: 0;
    display: block;
    max-width: 90px;
    min-width: 90px;
    width: 90px;
  }
`;

const PoweredByPromo: FC<Props> = () => {
  return (
    <Container>
      <p>{`Powered by   `}</p>
      <img src="https://i.imgur.com/bihgsf7.png" alt="ImpactBoard" />
    </Container>
  );
};

export default PoweredByPromo;
